/** Stopwatch display text. */

const MS_PER_HOUR = 3_600_000;

const pad2 = (value: number): string => String(value).padStart(2, "0");

/** True once the display needs an hours column (an hour or more). */
export function showsHours(ms: number): boolean {
  return ms >= MS_PER_HOUR;
}

/**
 * mm:ss.cc under an hour, h:mm:ss.cc from one hour on, with the elapsed time cut (not
 * rounded) to hundredths of a second.
 */
export function formatStopwatch(ms: number): string {
  const totalCentis = Math.floor(Math.max(0, ms) / 10);
  const centis = totalCentis % 100;
  const totalSeconds = Math.floor(totalCentis / 100);
  const seconds = totalSeconds % 60;
  const totalMinutes = Math.floor(totalSeconds / 60);
  const minutes = totalMinutes % 60;
  const hours = Math.floor(totalMinutes / 60);
  const tail = `${pad2(seconds)}.${pad2(centis)}`;
  if (hours > 0) {
    return `${hours}:${pad2(minutes)}:${tail}`;
  }
  return `${pad2(minutes)}:${tail}`;
}
